export default "__VITE_ASSET__06184abd__"